import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputField from '../common/InputField';
import Button from '../common/Button';
import Logo from '../common/Logo';
import {Eye, EyeOff } from 'lucide-react';

const AdminLoginForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form onSubmit={handleSubmit} className="">
      {/* Logo centrato */}
      <div className="flex justify-center mb-6">
        <Logo />
      </div>

      {/* Header con icona admin */}
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold mb-2">Login Amministratore</h2>
        <p className="text-gray-600 text-sm">
          Accedi all'area amministrativa
        </p>
      </div>

      {/* Campo email */}
      <InputField
        type="email"
        name="email"
        placeholder="Email"
        className="mb-4 w-full border border-orange-300 rounded-md p-2 focus:outline-none"
        value={formData.email}
        onChange={handleChange}
        required
      />

      {/* Campo password con toggle visibilità */}
      <div className="relative mb-6">
        <InputField
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Password"
          className="w-full border border-orange-300 rounded-md p-2 pr-10 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          onClick={togglePasswordVisibility}
        >
          {showPassword ? (
            <EyeOff size={20} />
          ) : (
            <Eye size={20} />
          )}
        </button>
      </div>

      {/* Pulsante di submit */}
      <Button
        type="submit"
        text="Accedi"
        className="w-full bg-orange-500 text-white py-3 rounded-md hover:bg-orange-600 transition-colors"
      />
    </form>
  );
};

AdminLoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default AdminLoginForm;